import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Builder } from '@builder.io/react';
import {
  LandingPageV2State,
  updateNotifications,
} from '../../containers/LandingPageV2/LandingPageV2.duck';
import SubscribeForm, { SubscribeFormProps } from './SubscribeForm';

/*
 * Wrapper for SubscribeForm used only in the Builder component to inject
 * the onSubscribe handler and Redux state
 */
const SubscribeFormBuilder: FC<Omit<SubscribeFormProps, 'onSubscribe'>> = (props) => {
  const dispatch = useDispatch();

  const { updateNotificationsStatus } = useSelector<any>(
    (state) => state.LandingPageV2
  ) as LandingPageV2State;

  const onSubscribe = useCallback(
    (params) => {
      dispatch(updateNotifications(params));
    },
    [dispatch]
  );

  return (
    <SubscribeForm
      {...props}
      updateNotificationsStatusForBuilderComponent={updateNotificationsStatus}
      onSubscribe={onSubscribe}
    />
  );
};

Builder.registerComponent(SubscribeFormBuilder, {
  name: 'Subscribe Form',
  inputs: [
    //  Button styles
    {
      name: 'buttonBackgroundColor',
      type: 'color',
      defaultValue: '#FFFFFF',
      friendlyName: 'Subscribe Button Background Color',
    },
    {
      name: 'buttonBorderColor',
      type: 'color',
      defaultValue: '#000000',
      friendlyName: 'Subscribe Button Border Color',
    },
    {
      name: 'buttonTextColor',
      type: 'color',
      defaultValue: '#000000',
      friendlyName: 'Subscribe Button Text Color',
    },

    // Shared input styles (dropdown + email)
    {
      name: 'inputFieldBorderColor',
      type: 'color',
      defaultValue: '#000000',
      friendlyName: 'Input Field Border Color',
    },
    {
      name: 'inputFieldTextColor',
      type: 'color',
      defaultValue: '#000000',
      friendlyName: 'Input Field Text Color',
    },

    // Success message styles
    {
      name: 'successMessageColor',
      type: 'color',
      defaultValue: '#000000',
      friendlyName: 'Success Message Color',
    },
    {
      name: 'successMessageTextAlign',
      type: 'string',
      enum: ['left', 'center', 'right'],
      defaultValue: 'center',
      friendlyName: 'Success Message Text Alignment',
    },
  ],
});

export default SubscribeFormBuilder;
